import './navbar.css';
// eslint-disable-next-line import/named
import { CustomUserClaim } from "@okta/okta-auth-js";
import { useOktaAuth } from "@okta/okta-react";
import { config } from '../../utils/config/config';
import { useDataApiServices, useDataApiSpacesByServiceId } from '../../Hooks/useDataServicesApi';
import { useEffect, useState } from 'react';
import { useDataApi as useDataUserApi } from '../../Hooks/useDataUsersApi';
import { Article } from '../../services/coworkerApiCalls/Article/ArticlesTypes';
import { useDataApiArticleByCategoryBySpace } from '../../Hooks/useDataArticlesApi';
import React from 'react';
import { ServiceUser } from '../../services/coworkerApiCalls/User/User';
import Modal from 'react-modal';

function ensureArray(customClaim: CustomUserClaim | CustomUserClaim[]): CustomUserClaim[] {
    // Vérifie si 'customClaim' est déjà un tableau
    // eslint-disable-next-line unicorn/prefer-ternary
    if (Array.isArray(customClaim)) {
        return customClaim;
    } else {
        // Si ce n'est pas un tableau, on l'encapsule dans un tableau
        return [customClaim];
    }
}


/**
 * @function NavBar displays the desktop version of the navigation menu
 * @returns {JSX.Element} HTML content
 */
function NavBar() {
    const { authState } = useOktaAuth();
    const groups = authState!.idToken!.claims.groups;
    const token = authState!.idToken!.idToken;


    // eslint-disable-next-line unicorn/consistent-function-scoping
    const handleNavigation = (path: string) => {
        window.location.href = path; // Change l'URL et recharge la page
    };
    const delayNavigation = (path: string, delay: number) => {
      setTimeout(() => {
        handleNavigation(path);
      }, delay);
    };

    // To have the last space choosed by the user 
    const initialLocalStorageSpaceId = localStorage.getItem("ID_SPACE");
    
    const connectedUser = useDataUserApi();
    const [spaceByServiceIdEdit, setSpacesByServiceIdEdit] = useState(
        initialLocalStorageSpaceId ? Number.parseInt(initialLocalStorageSpaceId, 10) : 76
    );
    
    // To have the right spaces depends on the connected user services
    const allSpacesByServiceId = useDataApiSpacesByServiceId(connectedUser?.idDepartment || 1);

    // if space id change due to a new choice of the user in select menu, the value in local storage will also change
    useEffect(() => {
        localStorage.setItem("ID_SPACE", JSON.stringify(spaceByServiceIdEdit));
    }, [spaceByServiceIdEdit]);

    // if we don't have a charter or informations or restaurants section, no links in navbar.
    const charter: Article | undefined = useDataApiArticleByCategoryBySpace(5);
    const informations : Article | undefined = useDataApiArticleByCategoryBySpace(3);
    const restaurants : Article | undefined = useDataApiArticleByCategoryBySpace(4);

    // To avoid one person to choice the default option
    const handleSpaceByServiceIdChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = Number.parseInt(event.target.value);
        if (selectedValue !== 0) { 
            setSpacesByServiceIdEdit(selectedValue);
            delayNavigation("/", 0);
        }
    };

    // Modal Part 
    
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [serviceIdEdit, setServiceIdEdit] = useState(1);
    const [spaceIdEdit, setSpaceIdEdit] = useState(0);

    // To have all spaces depends on service which is choose in the first list of the modal
    const allSpaces = useDataApiSpacesByServiceId(serviceIdEdit);
    
    const allServices = useDataApiServices();

    const handleServiceIdChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = Number.parseInt(event.target.value);
        if (selectedValue !== 0) { 
            setServiceIdEdit(selectedValue);
        }
    };

    const handleSpaceIdChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSpaceIdEdit(Number.parseInt(event.target.value));
    };
    
    function closeModal() {
        setModalIsOpen(false);
    }

    // To display the modal when the site doesn't have an ID_SPACE in local storage
    useEffect(() => {
        const storedValue = localStorage.getItem("ID_SPACE");
        if(storedValue){
            const parseValue  = Number.parseInt(storedValue, 10);
            if (parseValue == undefined || parseValue == 76) { 
                setModalIsOpen(true);
            }
        }
    }, []); 
    
    const modalStyles = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white', 
        padding: '2rem',
        borderRadius: '0.5rem', 
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        width: '80%', 
        maxWidth: '800px',
      },
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      },
    };

    // To submit the form
    const handleSubmit = (event: React.FormEvent) => {
      event.preventDefault();
      void ServiceUser(token, serviceIdEdit)
      localStorage.setItem("ID_SPACE", JSON.stringify(spaceIdEdit));
      delayNavigation("/", 2000);
      closeModal();
    }

    return (
        <ul className="flex sticky justify-between navigationBar sm:flex hidden">
            <div className="flex">
                {/* Utilisation de onClick au lieu de Link */}
                <li className="navigationElement" onClick={() => handleNavigation('/')}>Réservation</li>
                {informations?.id != 0 &&
                    <li className="navigationElement" onClick={() => handleNavigation('/informations')}>Informations</li>
                }
                {charter?.id != 0 &&
                    <li className="navigationElement" onClick={() => handleNavigation('/charte')}>Charte Coworking</li>
                }
                {restaurants?.id != 0 &&
                    <li className="navigationElement" onClick={() => handleNavigation('/restaurants')}>Restaurants</li>

                }
                <li className="navigationElement" onClick={() => handleNavigation('/articles')}>Articles</li>
                <li className="navigationElement" onClick={() => handleNavigation('/spaces')}>Espaces</li>
                <li className="navigationElement" onClick={() => handleNavigation('/departments')}>Services</li>
                
                {ensureArray(groups).includes(`GG_APCOWORK_${config.ENV_GROUP}_EDITOR`) ?
                <>
                  
                </>
                : <>
                </>}
            </div>
            <div className="flex">
                {/* Ce lien est poussé à droite */}
                {/* <li className="navigationElement" onClick={() => handleNavigation('/profil')}>Mon Profil</li> */}
                
                {/* it's the dropdown to choose your default space*/}
                {allSpacesByServiceId && (
                    <select
                        name="spacesByServiceId"
                        value={spaceByServiceIdEdit || ''}
                        onChange ={handleSpaceByServiceIdChange}
                        className="mt-1 block text-black w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
                        defaultValue=""
                    >
                        <option hidden value="">Choisir l'espace</option>
                        {allSpacesByServiceId.map((space) => (
                            <option key={space.id} value={space.id}>
                                {space.name}
                            </option>
                        ))}
                        {allSpacesByServiceId.length === 0 && (
                            <option value="" disabled>
                                Aucune espace n'est disponible.
                            </option>
                        )}
                    </select>
                )}
            </div>
            
            {modalIsOpen && 
              <div>
                  <Modal
                    isOpen={modalIsOpen}
                    contentLabel="Bienvenue et choix du service"
                    style={modalStyles}
                  >
                    <form onSubmit={handleSubmit} action="/articles" method="post" className="flex flex-col gap-6 rounded-lg p-8">
                      <h2 className="text-2xl font-semibold">Bienvenue sur votre espace CoWorking !</h2>
                      <p className="mb-2">Veuillez configurer votre espace :</p>
                      {allServices && (
                        <div className="form-group w-full md:w-1/2">
                          <label htmlFor="categoryId" className="text-lg font-semibold mb-2">Liste des services</label>
                          <select
                            name="categoryId"
                            value={serviceIdEdit || ''}
                            onChange={handleServiceIdChange}
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
                            defaultValue=""
                          >
                            <option hidden value={0}>Selectionnez votre service</option>
                            {allServices.map(service => (
                              <option key={service.id} value={service.id}>
                                {service.name}
                              </option>
                            ))}
                            {allServices.length === 0 && (
                              <option value="" disabled>Aucun service disponible</option>
                            )}
                          </select>
                        </div>
                      )}
                      {allSpaces && (
                        <div className="form-group w-full md:w-1/2">
                          <label htmlFor="categoryId" className="text-lg font-semibold mb-2">Liste des espaces</label>
                          <select
                            name="categoryId"
                            value={spaceIdEdit || 0}
                            onChange={handleSpaceIdChange}
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
                          >
                            <option value={0}>Choisissez votre espace favori</option>
                            {allSpaces.map(space => (
                              <option key={space.id} value={space.id}>
                                {space.name}
                              </option>
                            ))}
                            {allSpaces.length === 0 && (
                              <option value="" disabled>Aucun espace disponible</option>
                            )}
                          </select>
                        </div>
                      )}
                      {serviceIdEdit != 0 && spaceIdEdit !=0  && (
                        <button
                          type="submit"
                          className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                          Confirmer la sélection
                        </button>
                      )}
                    </form>
                  </Modal>
              </div>
            }
            
        </ul>


    );
}

export { NavBar };